import apiClient from '../client.js'

async function createTemplate(scope, payload) {
  return apiClient.post(`/${scope}/tickets/templates`, payload)
}

async function updateTemplate(scope, id, patch) {
  return apiClient.patch(`/${scope}/tickets/templates/${id}`, patch)
}

async function deleteTemplate(scope, id) {
  return apiClient.delete(`/${scope}/tickets/templates/${id}`)
}

class TemplateService {
  create = {
    /**
     * Create a template under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {object} payload
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async template(scope, payload) {
      return createTemplate(scope, payload)
    },
  }

  update = {
    /**
     * Update one template under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @param {object} patch
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async template(scope, id, patch) {
      return updateTemplate(scope, id, patch)
    },
  }

  delete = {
    /**
     * Delete one template under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async template(scope, id) {
      return deleteTemplate(scope, id)
    },
  }
}

export default new TemplateService()
